module.exports = __webpack_public_path__ + "img/head.27ba266d.png";